module.exports = __webpack_public_path__ + "img/moregame.bb5467b9.png";